import Stack from '@/design_system/Stack';
import Paragraph from '@/design_system/Typography/Paragraph';

export const Comment = ({ comment }: { comment: string }) => (
  <Stack
    className="bg-neutral-100"
    style={{
      padding: '8px 12px',
      borderRadius: '0.5rem',
    }}
  >
    <Paragraph
      style={{
        display: '-webkit-box',
        WebkitLineClamp: 2,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
      }}
    >
      {comment}
    </Paragraph>
  </Stack>
);
